import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'

import { transition } from './../../../common/Mixins'
import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { ImageStyled } from './../../atoms/Image/styles'
import { TimelineItemStyleProps } from './types'

const TimelineStyled = styled.div<WithTheme>`
  position: relative;
  max-width: 100%;
  margin: 0 auto;

  @media ${media.phone} {
    padding-top: 1.25rem;
    &:after {
      content: '';
      position: absolute;
      width: 1px;
      background-color: ${({ theme }) => theme.colors.gray3};
      height: calc(100% - 5.875rem);
      bottom: 0;
      left: 50%;
    }
  }
`

const TimelineItemContentStyled = styled.div<WithTheme>`
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
`

const TimelineItemImageStyled = styled.div`
  margin-bottom: 1rem;
  .gatsby-image-wrapper img {
    width: auto;
  }

  @media ${media.maxPhone} {
    display: flex;
    justify-content: center;

    ${ImageStyled} {
      width: auto;
    }
  }
`

const TimelineItemTitleStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`

const TimelineItemIconStyled = styled.div`
  display: flex;
  padding-left: 2rem;
  @media ${media.phone} {
    display: none;
  }
`

const TimelineItemBodyStyled = styled.div<WithTheme<TimelineItemStyleProps>>`
  font-size: 15px;
  line-height: 1.6;

  @media ${media.maxPhone} {
    ${transition}
    display: none;
    box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
    text-align: center;
    padding: 0.875rem;

    ${({ isAccordionActive }) =>
      isAccordionActive &&
      css`
        display: block;
      `};
  }
`

const TimelineItemHeadStyled = styled.div<WithTheme<TimelineItemStyleProps>>`
  position: relative;
  color: ${({ theme }) => theme.colors.green};
  margin-bottom: 1rem;

  @media ${media.maxPhone} {
    top: -0.0625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.125rem;

    ${({ isAccordionActive }) =>
      isAccordionActive &&
      css`
        ${TimelineItemIconStyled} {
          svg {
            transform: rotate(90deg);
          }
        }
      `};
  }
`

const TimelineItemStyled = styled.div<WithTheme>`
  position: relative;
  width: 100%;

  @media ${media.maxPhone} {
    &:not(:last-child) {
      margin-bottom: 2.75rem;
    }
  }

  @media ${media.phone} {
    width: 50%;

    &:nth-child(odd) {
      left: 0;
      text-align: right;
      padding: 0.625rem 4.5625rem;
      ${TimelineItemHeadStyled} {
        &:after {
          ${({ theme }) =>
            theme.direction === 'rtl'
              ? css`
                  left: -6.125rem;
                `
              : css`
                  right: -6.125rem;
                `}
        }
        &:before {
          ${({ theme }) =>
            theme.direction === 'rtl'
              ? css`
                  left: -7.3125rem;
                `
              : css`
                  right: -7.3125rem;
                `}
        }
      }
    }

    &:nth-child(even) {
      ${({ theme }) => (theme.direction === 'rtl' ? 'left: -50%' : 'left: 50%')};
      padding: 0.625rem 3.75rem;
      ${TimelineItemHeadStyled} {
        &:after {
          ${({ theme }) =>
            theme.direction === 'rtl'
              ? css`
                  right: -5.3125rem;
                `
              : css`
                  left: -5.3125rem;
                `}
        }
        &:before {
          ${({ theme }) =>
            theme.direction === 'rtl'
              ? css`
                  right: -6.5rem;
                `
              : css`
                  left: -6.5rem;
                `}
        }
      }
    }
    ${TimelineItemHeadStyled} {
      &:after,
      &:before {
        content: '';
        position: absolute;
        border-radius: 50%;
        box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
        background-color: ${({ theme }) => theme.colors.white};
      }

      &:after {
        width: 3.125rem;
        height: 3.125rem;
        top: -4.375rem;
        z-index: 2;
      }
      &:before {
        width: 5.5rem;
        height: 5.5rem;
        opacity: 0.5;
        z-index: 1;
        top: -5.625rem;
      }
    }
  }
`

export {
  TimelineStyled,
  TimelineItemStyled,
  TimelineItemContentStyled,
  TimelineItemImageStyled,
  TimelineItemTitleStyled,
  TimelineItemBodyStyled,
  TimelineItemHeadStyled,
  TimelineItemIconStyled
}
